/**
 * Environment detection and configuration
 * Provides unified configuration for dev, preview, and production modes
 */

export const ENV_TYPES = {
  DEVELOPMENT: 'development',
  PREVIEW: 'preview', 
  PRODUCTION: 'production'
}

/**
 * Detect current environment based on hostname, port, and build mode
 */
export const detectEnvironment = () => {
  const { hostname, port } = window.location
  
  // Force production mode for zenstarstudio.com
  if (hostname === 'zenstarstudio.com') {
    return ENV_TYPES.PRODUCTION
  }
  
  // Development mode (Vite dev server)
  if (hostname === 'localhost' && port === '5181') {
    return ENV_TYPES.DEVELOPMENT
  }
  
  // Preview mode (Vite preview server)
  if (hostname === 'localhost' && port === '4173') {
    return ENV_TYPES.PREVIEW
  }
  
  // Production mode (any other hostname)
  return ENV_TYPES.PRODUCTION
}

/**
 * Get API configuration based on current environment
 */
export const getApiConfig = () => {
  const env = detectEnvironment()
  
  switch (env) {
    case ENV_TYPES.DEVELOPMENT:
      return {
        baseURL: 'http://localhost:8000/api',
        authBaseURL: 'http://localhost:8000/auth'
      }
      
    case ENV_TYPES.PREVIEW:
      return {
        baseURL: '/squarehead/api',
        authBaseURL: '/squarehead/auth'
      }
      
    case ENV_TYPES.PRODUCTION:
    default:
      return {
        baseURL: `${window.location.origin}/squarehead/api`,
        authBaseURL: `${window.location.origin}/squarehead/auth`
      }
  }
}

/**
 * Check if we're in a local development environment
 */
export const isLocalEnvironment = () => {
  const env = detectEnvironment()
  return env === ENV_TYPES.DEVELOPMENT || env === ENV_TYPES.PREVIEW
}

/**
 * Get frontend URL for email links based on environment
 */
export const getFrontendUrl = () => {
  const env = detectEnvironment()
  
  switch (env) {
    case ENV_TYPES.DEVELOPMENT:
      return 'http://localhost:5181'
      
    case ENV_TYPES.PREVIEW:
      return 'http://localhost:4173/squarehead'
      
    case ENV_TYPES.PRODUCTION:
    default:
      return `${window.location.origin}/squarehead`
  }
}

export default {
  detectEnvironment,
  getApiConfig,
  isLocalEnvironment,
  getFrontendUrl,
  ENV_TYPES
}